module.exports = __webpack_public_path__ + "static/media/qualitas-checkmark.c7ada83c.svg";